import React, { useCallback } from 'react';
import styled from 'styled-components/macro';
import { Redirect, useParams } from 'react-router-dom';
import useAxiosRequest from 'Common/hooks/useAxiosRequest';
import Loader from 'Common/components/Loader';
import RetryLoading from 'Common/components/RetryLoading';
import useQueryParameter from 'Common/hooks/useQueryParameter';
import { WarningRounded } from '@material-ui/icons';
import OuterBox from 'Common/components/Boxes/OuterBox';
import OuterBoxTitle from 'Common/components/Boxes/OuterBoxTitle';
import colors from 'Common/constants/colors';
import WarningMessage from 'Common/components/Modals/WarningMessage';
import getPublicTemplateQuestionFilesDownloadRequest
    from 'ProjectManager/Template/Common/api/downloadRequest/getPublicTemplateQuestionFilesDownloadRequest';

const Wrapper = styled(OuterBox)`
  padding: 20px;
`;

const Text = styled.div`
  color: ${colors.GRAY};

  p {
    margin: 30px 0;

    strong {
      line-height: 24px;
    }
  }
`;

const TemplateQuestionFilesExpiredDownloadRequest = () => {
    const {
        templateId,
        questionId,
        isCustomQuestion,
        templateQuestionFilesDownloadRequestId,
    } = useParams();

    const [checksum] = useQueryParameter('checksum');

    const request = useCallback(
        cancelToken =>
            getPublicTemplateQuestionFilesDownloadRequest(
                templateId,
                questionId,
                Boolean(parseInt(isCustomQuestion)),
                templateQuestionFilesDownloadRequestId,
                checksum,
                [],
                cancelToken,
            ),
        [
            templateId,
            questionId,
            isCustomQuestion,
            templateQuestionFilesDownloadRequestId,
            checksum,
        ],
    );

    const {
        data: downloadRequest,
        loadData: loadDownloadRequest,
        isLoading,
        hasError,
        error,
    } = useAxiosRequest(request, null);

    if (hasError) {
        const responseStatusCode = error?.response?.status;

        if (responseStatusCode === 404 || responseStatusCode === 400) {
            return <Redirect to="/" />;
        }

        return <RetryLoading onRetry={loadDownloadRequest} />;
    }

    if (isLoading) {
        return <Loader />;
    }

    return (
        <Wrapper>
            <OuterBoxTitle>
                {`Projektvorlagedateien - ${downloadRequest.templateName}`}
            </OuterBoxTitle>
            <Text>
                <p>
                    <strong>Frage:</strong>
                    <br />
                    {downloadRequest.questionText}
                </p>
                <p>
                    <strong>Projektfeld:</strong>
                    <br />
                    {downloadRequest.topicName}
                </p>
                <WarningMessage>
                    <WarningRounded />
                    Der Link ist abgelaufen und nicht mehr gültig.
                </WarningMessage>
            </Text>
        </Wrapper>
    );
};

export default TemplateQuestionFilesExpiredDownloadRequest;
